<template>
  <section>
    <div class="l-page-content l-feedback-content">
      <h1 class="section-title">
        Укажите свои данные, и наш менеджер свяжется с вами, чтобы ответить на ваши вопросы.
      </h1>

      <form @submit.prevent="handleSubmit" class="feedback">
        <div class="feedback__group">
          <div class="feedback__item">
            <input
              type="text"
              placeholder="ФИО"
              v-model="personName"
              required
              :readonly="loading"
            />
          </div>
          <div class="feedback__item">
            <input
              type="text"
              placeholder="Компания"
              v-model="companyName"
              required
              :readonly="loading"
            />
          </div>
        </div>

        <div class="feedback__group">
          <div class="feedback__item">
            <input
              type="text"
              placeholder="Телефон или email"
              v-model="contact"
              required
              :readonly="loading"
            />
          </div>
        </div>

        <div class="feedback__group">
          <PolicyAgreement v-model="agree" class="feedback__item" />
        </div>

        <div class="feedback__group">
          <div class="feedback__item feedback__item--centred">
            <button
              type="submit"
              class="button button--primary-lighten feedback__submit-btn"
              :disabled="!agree"
            >
              Отправить
              <SpinnerRing
                v-if="loading"
                class="feedback__btn-loader"
              />
            </button>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import CheckboxInline from '@/components/form/CheckboxInline.vue';
import PolicyAgreement from '@/components/PolicyAgreement/PolicyAgreement.vue';
import SpinnerRing from '@/components/Spinner/SpinnerRing.vue';
import { sendFeedback } from '@/api/partnerInfo';

export default {
  components: { CheckboxInline, PolicyAgreement, SpinnerRing },

  data() {
    return {
      personName: '',
      companyName: '',
      contact: '',
      loading: false,
      agree: false,
    };
  },
  methods: {
    async handleSubmit() {
      if (!this.agree || this.loading) return;

      this.loading = true;
      await sendFeedback(this.personName, this.companyName, this.contact);
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.l-feedback-content {
  @include device-from(tablet) {
    width: 60%;
  }
}

.feedback {
  &__submit-btn {
    position: relative;
    font-weight: 600;
    font-size: 1.25rem;
    line-height: 1.5rem;
    margin: 1.5rem 0 4rem;
    padding: 1rem 5rem;
  }

  &__btn-loader {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 1.5rem;
    top: 0;
    bottom: 0;
  }

  &__group {
    display: flex;
    max-width: 750px;
    margin: 0 auto;

    @include device-until(tablet) {
      flex-wrap: wrap;
    }
  }

  &__item {
    margin: 0 1rem;
    flex: 1;

    &--centred {
      text-align: center;
    }

    @include device-until(tablet) {
      flex: auto;
      width: 100%;
    }
  }
}
</style>
